import ExportDiagnosisModal from './ExportDiagnosisModal';

export default ExportDiagnosisModal;
